import { SURVEY_SERIES_LIST, SURVEY_SERIES_LIST_ERROR, SURVEY_SERIES_LIST_SUCCESS, SURVEY_SERIES_UPDATE_DATA } from './constants';

export default function surveySeriesReducer(state, action) {
	switch (action.type) {
	case SURVEY_SERIES_LIST :
		return { ...state, loading : true, error : false };
	case SURVEY_SERIES_LIST_SUCCESS :
		return { ...state, surveySeries : action.payload, loading : false, error : false};
	case SURVEY_SERIES_LIST_ERROR : 
		return { ...state, loading : false, error : true };
	case SURVEY_SERIES_UPDATE_DATA :
		return { ...state, updateData : action.payload };
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}